export const topLineData = [
  [
    { xAxis: 0.1, yAxis: 49.5 },
    { xAxis: 0.1, yAxis: 0 },
  ],
  [
    { xAxis: 1, yAxis: 49.5 },
    { xAxis: 1, yAxis: 0 },
  ],
  [
    { xAxis: 2, yAxis: 49.8 },
    { xAxis: 2, yAxis: 0 },
  ],
  [
    { xAxis: 3, yAxis: 51 },
    { xAxis: 3, yAxis: 0 },
  ],
  [
    { xAxis: 4, yAxis: 52 },
    { xAxis: 4, yAxis: 0 },
  ],
  [
    { xAxis: 5, yAxis: 54 },
    { xAxis: 5, yAxis: 0 },
  ],
  [
    { xAxis: 6, yAxis: 57 },
    { xAxis: 6, yAxis: 0 },
  ],
  [
    { xAxis: 7, yAxis: 60 },
    { xAxis: 7, yAxis: 0 },
  ],
  [
    { xAxis: 8, yAxis: 63 },
    { xAxis: 8, yAxis: 0 },
  ],
  [
    { xAxis: 9, yAxis: 66 },
    { xAxis: 9, yAxis: 0 },
  ],
  [
    { xAxis: 10, yAxis: 70 },
    { xAxis: 10, yAxis: 0 },
  ],
  [
    { xAxis: 11, yAxis: 74 },
    { xAxis: 11, yAxis: 0 },
  ],
  [
    { xAxis: 12, yAxis: 78 },
    { xAxis: 12, yAxis: 0 },
  ],
  [
    { xAxis: 13, yAxis: 83 },
    { xAxis: 13, yAxis: 0 },
  ],
  [
    { xAxis: 14, yAxis: 88 },
    { xAxis: 14, yAxis: 0 },
  ],
  [
    { xAxis: 15, yAxis: 93 },
    { xAxis: 15, yAxis: 0 },
  ],
  [
    { xAxis: 16, yAxis: 98 },
    { xAxis: 16, yAxis: 0 },
  ],
  [
    { xAxis: 17, yAxis: 104 },
    { xAxis: 17, yAxis: 0 },
  ],
  [
    { xAxis: 18, yAxis: 110 },
    { xAxis: 18, yAxis: 0 },
  ],
  [
    { xAxis: 19, yAxis: 117 },
    { xAxis: 19, yAxis: 0 },
  ],
  [
    { xAxis: 20, yAxis: 123 },
    { xAxis: 20, yAxis: 0 },
  ],
  [
    { xAxis: 21, yAxis: 130 },
    { xAxis: 21, yAxis: 0 },
  ],
  [
    { xAxis: 22, yAxis: 137 },
    { xAxis: 22, yAxis: 0 },
  ],
  [
    { xAxis: 23, yAxis: 144 },
    { xAxis: 23, yAxis: 0 },
  ],
  [
    { xAxis: 24, yAxis: 152 },
    { xAxis: 24, yAxis: 0 },
  ],
  [
    { xAxis: 24.9, yAxis: 159 },
    { xAxis: 24.9, yAxis: 0 },
  ],
]

export const bottomLineData = [
  [
    { xAxis: 0.1, yAxis: 0 },
    { xAxis: 0.1, yAxis: -20 },
  ],
  [
    { xAxis: 1, yAxis: 0 },
    { xAxis: 1, yAxis: -20 },
  ],
  [
    { xAxis: 2, yAxis: 0 },
    { xAxis: 2, yAxis: -21 },
  ],
  [
    { xAxis: 3, yAxis: 0 },
    { xAxis: 3, yAxis: -20 },
  ],
  [
    { xAxis: 4, yAxis: 0 },
    { xAxis: 4, yAxis: -22 },
  ],
  [
    { xAxis: 5, yAxis: 0 },
    { xAxis: 5, yAxis: -24 },
  ],
  [
    { xAxis: 6, yAxis: 0 },
    { xAxis: 6, yAxis: -27 },
  ],
  [
    { xAxis: 7, yAxis: 0 },
    { xAxis: 7, yAxis: -30 },
  ],
  [
    { xAxis: 8, yAxis: 0 },
    { xAxis: 8, yAxis: -33 },
  ],
  [
    { xAxis: 9, yAxis: 0 },
    { xAxis: 9, yAxis: -36 },
  ],
  [
    { xAxis: 10, yAxis: 0 },
    { xAxis: 10, yAxis: -40 },
  ],
  [
    { xAxis: 11, yAxis: 0 },
    { xAxis: 11, yAxis: -44 },
  ],
  [
    { xAxis: 12, yAxis: 0 },
    { xAxis: 12, yAxis: -48 },
  ],
  [
    { xAxis: 13, yAxis: 0 },
    { xAxis: 13, yAxis: -53 },
  ],
  [
    { xAxis: 14, yAxis: 0 },
    { xAxis: 14, yAxis: -58 },
  ],
  [
    { xAxis: 15, yAxis: 0 },
    { xAxis: 15, yAxis: -63 },
  ],
  [
    { xAxis: 16, yAxis: 0 },
    { xAxis: 16, yAxis: -69 },
  ],
  [
    { xAxis: 17, yAxis: 0 },
    { xAxis: 17, yAxis: -74 },
  ],
  [
    { xAxis: 18, yAxis: 0 },
    { xAxis: 18, yAxis: -80 },
  ],
  [
    { xAxis: 19, yAxis: 0 },
    { xAxis: 19, yAxis: -87 },
  ],
  [
    { xAxis: 20, yAxis: 0 },
    { xAxis: 20, yAxis: -93 },
  ],
  [
    { xAxis: 21, yAxis: 0 },
    { xAxis: 21, yAxis: -100 },
  ],
  [
    { xAxis: 22, yAxis: 0 },
    { xAxis: 22, yAxis: -107 },
  ],
  [
    { xAxis: 23, yAxis: 0 },
    { xAxis: 23, yAxis: -115 },
  ],
  [
    { xAxis: 24, yAxis: 0 },
    { xAxis: 24, yAxis: -122 },
  ],
  [
    { xAxis: 24.9, yAxis: 0 },
    { xAxis: 24.9, yAxis: -129 },
  ],
]
